

// Grouped item child definition
class GroupedItemChildVM {
  uuid: string;
  type: string;
  value: string | null;
  options: any;
  parent_uuid: string | null;
  children: GroupedItemChildVM[];

  constructor(data?: Partial<GroupedItemChildVM>) {
    this.uuid = data?.uuid || ''
    this.type = data?.type || ''
    this.value = data?.value || null
    this.options = data?.options || {}
    this.parent_uuid = data?.parent_uuid || null
    this.children = data?.children ? data.children.map(child => (child)) : []
  }
}

// Grouped item definition
class GroupedItemVM {
  flat_items: GroupedItemChildVM[];
  uuid: string;
  type: string;
  value: any | null;
  options: any;
  items: GroupedItemChildVM[];
  parent_uuid?: string | null;

  constructor(data?: Partial<GroupedItemVM>) {
    this.flat_items = data?.flat_items ? data.flat_items.map(item => (item)) : []
    this.uuid = data?.uuid || ''
    this.type = data?.type || ''
    this.value = data?.value || null
    this.options = data?.options || {}
    this.items = data?.items ? data.items.map(item => item) : []
    this.parent_uuid = data?.parent_uuid || null
  }
}

// Grouped items definition
class GroupedItemsVM {
  [key: string]: GroupedItemVM;

  constructor(data?: Record<string, GroupedItemVM>) {
    if (data) {
      Object.keys(data).forEach(key => {
        this[key] = data[key] instanceof GroupedItemVM ? data[key] : new GroupedItemVM(data[key])
      })
    }
  }
}
export {GroupedItemsVM, GroupedItemVM, GroupedItemChildVM}
